export default __webpack_public_path__ + "9d4eadaa983d59abac1e5b7b121aa623.svg";